import React from 'react';
import Icon from '@material-ui/core/Icon';
import arrowRight from '@assets/arrow-right.svg';

function ArrowRight() {
  return (
    <Icon>
      <img alt="arrow" src={arrowRight} style={{ display: 'block' }} />
    </Icon>
  );
}

export default ArrowRight;
